// @ts-nocheck
import {Column} from 'react-table'
import {ProductInfoCell} from './ProductInfoCell'
import {EmployeeTwoStepsCell} from './EmployeeTwoStepsCell'
import {ProductActionsCell} from './ProductActionsCell'
import {ProductCustomHeader} from './ProductCustomHeader'
import {Product} from '../../core/_models'

const EmployeeColumns: ReadonlyArray<Column<Product>> = [
  {
    Header: (props) => (
      <ProductCustomHeader tableProps={props} title='S.No' className='min-w-125px' />
    ),
    accessor: 'serialNo',
  },
  {
    Header: (props) => (
      <ProductCustomHeader tableProps={props} title='Name' className='min-w-125px' />
    ),
    accessor: 'name',
  },
  {
    Header: (props) => (
      <ProductCustomHeader tableProps={props} title='Image' className='min-w-125px' />
    ),
    accessor: 'image',
    Cell: ({...props}) => <ProductInfoCell product={props.data[props.row.index]}  columnAccessor='image'/>,
  },

  {
    Header: (props) => (
      <ProductCustomHeader tableProps={props} title='Category' className='min-w-125px' />
    ),
    accessor: 'buysell_category.categoryName',
  },
  {
    Header: (props) => (
      <ProductCustomHeader tableProps={props} title='Status' className='min-w-125px' />
    ),
    accessor: 'enable_status',
    Cell: ({...props}) => <ProductInfoCell product={props.data[props.row.index]}  columnAccessor='status'/>,
  },

  {
    Header: (props) => (
      <ProductCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <ProductActionsCell prod={props.data[props.row.index]}   />,
  },
]

export {EmployeeColumns}
